module.exports = __webpack_public_path__ + "static/img/x.fc76777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x.jpg
// module id = 263
// module chunks = 1